import App from 'next/app'
import Head from "next/head";
import MessengerChat from '../components/MessengerChat/MessengerChat'
import TagManager from 'react-gtm-module'
import { createGlobalStyle, ThemeProvider } from 'styled-components'
import styledNormalize from 'styled-normalize'
import Layout from '../components/Layout'
import NoSsr from '../components/NoSsr'
import { getConfig, getCurrentlanguage } from '../utils/index'
import theme from '../theme'
import { SESSION_STORAGE_KEY } from '../utils/constant'
import { i18n, appWithTranslation } from '~/i18n'
import { withApollo } from '../lib/apollo'
import { ToastContainer } from 'react-toastify'
import Router from 'next/router'
import { ROUTES, LOGIN_REDIRECT_URL } from '../constant'
import 'bootstrap/dist/css/bootstrap.min.css';
// styles
import 'react-toastify/dist/ReactToastify.css'
import '../assets/scss/index.scss'
import { sendPageView } from '../utils/gtm'
import DownloadAppBanner from '../components/mobile-bottom-banner/DownloadAppBanner'
import ScheduleCalendar from '../components/MessengerChat/ScheduleCalendar'
import * as Sentry from '@sentry/browser'
import querystring from 'query-string'
import getcdn from "~/modules/get_cdn_link"

const tagManagerArgs = {
  gtmId: getConfig('REACT_APP_TAG_MANAGER'),
}

const GlobalStyle = createGlobalStyle`
  ${styledNormalize}
  .modal-video .modal-content {
    border: none;
    background-color: transparent !important;
  }
`

// if (process.env.ENV === 'production') {
Sentry.init({ dsn: "https://4afef7902f8849c6854674e7c88e089d@o283749.ingest.sentry.io/5241602" });
// }


class MyApp extends App {
  // static async getInitialProps({ Component, ctx }) {
    // const { query } = ctx
    // if (query.lang) {
    //   i18n.changeLanguage(query.lang)
    // }
  //   return {
  //     pageProps: Component.getInitialProps ? await Component.getInitialProps(ctx) : {},
  //     namespacesRequired: ['common', 'about'],
  //   }
  // }

  updateLang() {
    const query = querystring.parse(window.location.search);
    const languageLocal = getCurrentlanguage(query.lang)
    i18n.changeLanguage(languageLocal)
  }

  componentDidMount() {
    this.updateLang()
    TagManager.initialize(tagManagerArgs)
    sessionStorage.setItem(SESSION_STORAGE_KEY.AUTO, 2) // set init status = auto for messenger plugin

    const handleRouteChange = (url, ...rest) => {
      sendPageView(url)
    }
    Router.events.on('routeChangeComplete', handleRouteChange)
    if (window.AT) {
      window.AT.init({ campaign_id: 871, is_reoccur: 1, is_lastclick: 1 })
      window.AT.track()
    }

    var OneSignal = window.OneSignal || []
    OneSignal.push(function () {
      OneSignal.init({
        appId: getConfig('ENV') === 'production' ? getConfig('ONESIGNAL_APP_ID') : 'd9314ac5-e11b-4865-84de-ba5c6adf0d23',
        autoResubscribe: true,
      })
    })
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key])
      })

      Sentry.captureException(error)
    })

    super.componentDidCatch(error, errorInfo)
  }

  render() {
    const {
      Component,
      pageProps,
      router,
      router: { query },
    } = this.props
    const webview = pageProps.webview || query.webview

    if (process.browser && ![ROUTES.SIGN_IN, ROUTES.SIGN_UP, ROUTES.FORGOT_PASSWORD].includes(router.route)) {
      localStorage.setItem(LOGIN_REDIRECT_URL, window.location.href)
    }

    const isAuthRoute = [ROUTES.SIGN_UP, ROUTES.SIGN_IN, ROUTES.FORGOT_PASSWORD].includes(router.route)

    return (
      <>
      <Head>
        <title>Infina - Nền tảng đầu tư và tích lũy cho mọi người</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Infina - Nền tảng đầu tư và tích lũy cho mọi người" />
        <meta property="og:image" content={getcdn('/img/infina_preview_thumb.png')} />
        <meta
          name="description"
          content="Không còn sự phức tạp, không yêu cầu số vốn lớn, hạn chế rủi ro thấp nhất, giúp mọi người bắt đầu hành trình đầu tư một cách dễ dàng."
        />

        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          rel="stylesheet preload prefetch"
          as="style"
          href="https://fonts.googleapis.com/css?family=Muli:400,600,700&display=swap"
        />
        <link rel="preconnect" href="https://growsurf.com" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta property="fb:app_id" content="416109619218105" />
        <link rel="preconnect" href="https://static.accesstrade.vn" />
        <meta name="google-site-verification" content="CRxgZPRKc8cCd3oXBiNAc3vUjAB3N8v6DsC4FoUGsFY" />
        <script async src="https://static.accesstrade.vn/js/trackingtag/tracking.min.js" type="text/javascript" />
        <link rel="preconnect" href="https://cdn.onesignal.com" />
        <script async src="https://cdn.onesignal.com/sdks/OneSignalSDK.js"></script>
        {process.env.ENV === 'staging' && <meta name="robots" content="noindex" />}
        <meta name="google-site-verification" content="pMYENQKJRmRjcM331avu6lOn5BygUg3EfayNgPKA1nU" />
        <script type="text/javascript">
          {`(function(g,r,s,f){g.growsurf={};g.grsfSettings={campaignId:"nheuv0",version:"2.0.0"};s=r.getElementsByTagName("head")[0];f=r.createElement("script");f.async=1;f.src="https://growsurf.com/growsurf.js"+"?v="+g.grsfSettings.version;f.setAttribute("grsf-campaign", g.grsfSettings.campaignId);!g.grsfInit?s.appendChild(f):"";})(window,document);`}
        </script>
        <link rel="stylesheet preload" href="/iconmoon/style.css" />
        </Head>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <ScheduleCalendar />
          <div />
          <NoSsr>
            <MessengerChat {...pageProps} />
            <ToastContainer />
          </NoSsr>
          <Layout webview={webview}>
            <Component router={router} {...pageProps} />
            {!webview && !isAuthRoute && <DownloadAppBanner />}
          </Layout>
        </ThemeProvider>
      </>
    )
  }
}

export default withApollo(appWithTranslation(MyApp))
